import React from 'react';
import Button from '../ui/Button';
import FadeIn from '../ui/FadeIn';
import { useSiteInfo } from '../../context/SiteInfoContext';
import { IconPhone } from '../ui/Icons';

const CTASection = () => {
  const { siteInfo } = useSiteInfo();
  const phoneTel = siteInfo?.phone?.tel;

  return (
    <section className="cta-section" id="contact">
      <div className="container">
        <FadeIn>
          <h2>Ready to Drive Away Today?</h2>
          <p>
            Call the forecourt, drop by Noak Hill Road, or message us on WhatsApp
            — we're straightforward to deal with and happy to help.
          </p>
          <div className="cta-buttons">
            {phoneTel && (
              <Button variant="primary" href={`tel:${phoneTel}`}>
                <IconPhone /> Call Us Now
              </Button>
            )}
            <Button variant="outline" href="#inventory">
              View Inventory
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default CTASection;
